function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useId, useRef, useCallback, useEffect, createElement } from 'react';
import { XCircleIcon } from '@shopify/polaris-icons';
import { classNames, variationName } from '../../utilities/css.js';
import { useIsAfterInitialMount } from '../../utilities/use-is-after-initial-mount.js';
import { Key } from '../../types.js';
import { useEventListener } from '../../utilities/use-event-listener.js';
import styles from './TextField.scss.js';
import { Spinner as Spinner$1 } from './components/Spinner/Spinner.js';
import { Labelled, helpTextID } from '../Labelled/Labelled.js';
import { Connected } from '../Connected/Connected.js';
import { Resizer } from './components/Resizer/Resizer.js';
import { labelID } from '../Label/Label.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { Icon } from '../Icon/Icon.js';
import { Spinner } from '../Spinner/Spinner.js';
import { Text } from '../Text/Text.js';
function TextField(_ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    verticalContent = _ref.verticalContent,
    placeholder = _ref.placeholder,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    helpText = _ref.helpText,
    label = _ref.label,
    labelAction = _ref.labelAction,
    labelHidden = _ref.labelHidden,
    disabled = _ref.disabled,
    clearButton = _ref.clearButton,
    readOnly = _ref.readOnly,
    autoFocus = _ref.autoFocus,
    focused = _ref.focused,
    multiline = _ref.multiline,
    error = _ref.error,
    connectedRight = _ref.connectedRight,
    connectedLeft = _ref.connectedLeft,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    name = _ref.name,
    idProp = _ref.id,
    role = _ref.role,
    step = _ref.step,
    largeStep = _ref.largeStep,
    autoComplete = _ref.autoComplete,
    max = _ref.max,
    maxLength = _ref.maxLength,
    maxHeight = _ref.maxHeight,
    min = _ref.min,
    minLength = _ref.minLength,
    pattern = _ref.pattern,
    inputMode = _ref.inputMode,
    spellCheck = _ref.spellCheck,
    ariaOwns = _ref.ariaOwns,
    ariaControls = _ref.ariaControls,
    ariaExpanded = _ref.ariaExpanded,
    ariaActiveDescendant = _ref.ariaActiveDescendant,
    ariaAutocomplete = _ref.ariaAutocomplete,
    showCharacterCount = _ref.showCharacterCount,
    align = _ref.align,
    requiredIndicator = _ref.requiredIndicator,
    monospaced = _ref.monospaced,
    selectTextOnFocus = _ref.selectTextOnFocus,
    suggestion = _ref.suggestion,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'inherit' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    onClearButtonClick = _ref.onClearButtonClick,
    onChange = _ref.onChange,
    onSpinnerChange = _ref.onSpinnerChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    tone = _ref.tone,
    autoSize = _ref.autoSize,
    loading = _ref.loading;
  var i18n = useI18n();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = useState(Boolean(focused)),
    _useState4 = _slicedToArray(_useState3, 2),
    focus = _useState4[0],
    setFocus = _useState4[1];
  var isAfterInitial = useIsAfterInitialMount();
  var uniqId = useId();
  var id = idProp !== null && idProp !== void 0 ? idProp : uniqId;
  var textFieldRef = useRef(null);
  var inputRef = useRef(null);
  var textAreaRef = useRef(null);
  var prefixRef = useRef(null);
  var suffixRef = useRef(null);
  var loadingRef = useRef(null);
  var verticalContentRef = useRef(null);
  var buttonPressTimer = useRef();
  var spinnerRef = useRef(null);
  var getInputRef = useCallback(function () {
    return multiline ? textAreaRef.current : inputRef.current;
  }, [multiline]);
  useEffect(function () {
    var input = getInputRef();
    if (!input || focused === undefined) return;
    focused ? input.focus() : input.blur();
  }, [focused, verticalContent, getInputRef]);
  useEffect(function () {
    var input = inputRef.current;
    var isSupportedInputType = type === 'text' || type === 'tel' || type === 'search' || type === 'url' || type === 'password';
    if (!input || !isSupportedInputType || !suggestion) {
      return;
    }
    input.setSelectionRange(value.length, suggestion.length);
  }, [focus, value, type, suggestion]);
  var normalizedValue = suggestion ? suggestion : value;
  var normalizedStep = step != null ? step : 1;
  var normalizedMax = max != null ? max : Infinity;
  var normalizedMin = min != null ? min : -Infinity;
  var className = classNames(styles.TextField, Boolean(normalizedValue) && styles.hasValue, disabled && styles.disabled, readOnly && styles.readOnly, error && styles.error, tone && styles[variationName('tone', tone)], multiline && styles.multiline, focus && !disabled && styles.focus, variant !== 'inherit' && styles[variant], size === 'slim' && styles.slim);
  var inputType = type === 'currency' ? 'text' : type;
  var isNumericType = type === 'number' || type === 'integer';
  var iconPrefix = /*#__PURE__*/ /*#__PURE__*/React.isValidElement(prefix) && prefix.type === Icon;
  var prefixMarkup = prefix ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.Prefix, iconPrefix && styles.PrefixIcon),
    id: "".concat(id, "-Prefix"),
    ref: prefixRef
  }, prefix) : null;
  var suffixMarkup = suffix ? /*#__PURE__*/React.createElement("div", {
    className: styles.Suffix,
    id: "".concat(id, "-Suffix"),
    ref: suffixRef
  }, suffix) : null;
  var loadingMarkup = loading ? /*#__PURE__*/React.createElement("div", {
    className: styles.Loading,
    id: "".concat(id, "-Loading"),
    ref: loadingRef
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "small"
  })) : null;
  var characterCountMarkup = null;
  if (showCharacterCount) {
    var characterCount = normalizedValue.length;
    var characterCountLabel = maxLength ? i18n.translate('Polaris.TextField.characterCountWithMaxLength', {
      count: characterCount,
      limit: maxLength
    }) : i18n.translate('Polaris.TextField.characterCount', {
      count: characterCount
    });
    var characterCountClassName = classNames(styles.CharacterCount, multiline && styles.AlignFieldBottom);
    var characterCountText = !maxLength ? characterCount : "".concat(characterCount, "/").concat(maxLength);
    characterCountMarkup = /*#__PURE__*/React.createElement("div", {
      id: "".concat(id, "-CharacterCounter"),
      className: characterCountClassName,
      "aria-label": characterCountLabel,
      "aria-live": focus ? 'polite' : 'off',
      "aria-atomic": "true",
      onClick: handleClickChild
    }, characterCountText);
  }
  var clearButtonVisible = normalizedValue !== '';
  var clearButtonMarkup = clearButton && clearButtonVisible ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.ClearButton,
    onClick: handleClearButtonPress,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    visuallyHidden: true
  }, i18n.translate('Polaris.Common.clear')), /*#__PURE__*/React.createElement(Icon, {
    source: XCircleIcon,
    tone: "base"
  })) : null;
  var handleNumberChange = useCallback(function (steps) {
    var stepAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : normalizedStep;
    if (onChange == null && onSpinnerChange == null) {
      return;
    }
    // Returns the length of decimal places in a number
    var dpl = function dpl(num) {
      return (num.toString().split('.')[1] || []).length;
    };
    var numericValue = value ? parseFloat(value) : 0;
    if (isNaN(numericValue)) {
      return;
    }

    // Making sure the new value has the same length of decimal places as the
    // step / value has.
    var decimalPlaces = type === 'integer' ? 0 : Math.max(dpl(numericValue), dpl(stepAmount));
    var newValue = Math.min(Number(normalizedMax), Math.max(numericValue + steps * stepAmount, Number(normalizedMin)));
    if (onSpinnerChange != null) {
      onSpinnerChange(String(newValue.toFixed(decimalPlaces)), id);
    } else if (onChange != null) {
      onChange(String(newValue.toFixed(decimalPlaces)), id);
    }
  }, [id, normalizedMax, normalizedMin, onChange, onSpinnerChange, normalizedStep, type, value]);
  var handleSpinnerButtonRelease = useCallback(function () {
    clearTimeout(buttonPressTimer.current);
  }, []);
  var handleSpinnerButtonPress = useCallback(function (onChange) {
    var minInterval = 50;
    var decrementBy = 10;
    var interval = 200;
    var _onChangeInterval = function onChangeInterval() {
      if (interval > minInterval) interval -= decrementBy;
      onChange(0);
      buttonPressTimer.current = window.setTimeout(_onChangeInterval, interval);
    };
    buttonPressTimer.current = window.setTimeout(_onChangeInterval, interval);
    document.addEventListener('mouseup', handleSpinnerButtonRelease, {
      once: true
    });
  }, [handleSpinnerButtonRelease]);
  var spinnerMarkup = isNumericType && step !== 0 && !disabled && !readOnly ? /*#__PURE__*/React.createElement(Spinner$1, {
    onClick: handleClickChild,
    onChange: handleNumberChange,
    onMouseDown: handleSpinnerButtonPress,
    onMouseUp: handleSpinnerButtonRelease,
    ref: spinnerRef,
    onBlur: handleOnBlur
  }) : null;
  var style = multiline && height ? {
    height: height,
    maxHeight: maxHeight
  } : null;
  var handleExpandingResize = useCallback(function (height) {
    setHeight(height);
  }, []);
  var resizer = multiline && isAfterInitial ? /*#__PURE__*/React.createElement(Resizer, {
    contents: normalizedValue || placeholder,
    currentHeight: height,
    minimumLines: typeof multiline === 'number' ? multiline : 1,
    onHeightChange: handleExpandingResize
  }) : null;
  var describedBy = [];
  if (error) {
    describedBy.push("".concat(id, "Error"));
  }
  if (helpText) {
    describedBy.push(helpTextID(id));
  }
  if (showCharacterCount) {
    describedBy.push("".concat(id, "-CharacterCounter"));
  }
  var labelledBy = [];
  if (prefix) {
    labelledBy.push("".concat(id, "-Prefix"));
  }
  if (suffix) {
    labelledBy.push("".concat(id, "-Suffix"));
  }
  if (verticalContent) {
    labelledBy.push("".concat(id, "-VerticalContent"));
  }
  labelledBy.unshift(labelID(id));
  var inputClassName = classNames(styles.Input, align && styles[variationName('Input-align', align)], suffix && styles['Input-suffixed'], clearButton && styles['Input-hasClearButton'], monospaced && styles.monospaced, suggestion && styles.suggestion, autoSize && styles['Input-autoSize']);
  var handleOnFocus = function handleOnFocus(event) {
    setFocus(true);
    if (selectTextOnFocus && !suggestion) {
      var _input = getInputRef();
      _input === null || _input === void 0 || _input.select();
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  useEventListener('wheel', handleOnWheel, inputRef);
  function handleOnWheel(event) {
    if (document.activeElement === event.target && isNumericType) {
      event.stopPropagation();
    }
  }
  var input = /*#__PURE__*/createElement(multiline ? 'textarea' : 'input', _objectSpread(_objectSpread({
    name: name,
    id: id,
    disabled: disabled,
    readOnly: readOnly,
    role: role,
    autoFocus: autoFocus,
    value: normalizedValue,
    placeholder: placeholder,
    style: style,
    autoComplete: autoComplete,
    className: inputClassName,
    ref: multiline ? textAreaRef : inputRef,
    min: min,
    max: max,
    step: step,
    minLength: minLength,
    maxLength: maxLength,
    spellCheck: spellCheck,
    pattern: pattern,
    inputMode: inputMode,
    type: inputType,
    rows: getRows(multiline),
    size: autoSize ? 1 : undefined,
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined,
    'aria-labelledby': labelledBy.join(' '),
    'aria-invalid': Boolean(error),
    'aria-owns': ariaOwns,
    'aria-activedescendant': ariaActiveDescendant,
    'aria-autocomplete': ariaAutocomplete,
    'aria-controls': ariaControls,
    'aria-expanded': ariaExpanded,
    'aria-required': requiredIndicator
  }, normalizeAriaMultiline(multiline)), {}, {
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onClick: handleClickChild,
    onKeyPress: handleKeyPress,
    onKeyDown: handleKeyDown,
    onChange: !suggestion ? handleChange : undefined,
    onInput: suggestion ? handleChange : undefined,
    // 1Password disable data attribute
    'data-1p-ignore': autoComplete === 'off' || undefined,
    // LastPass disable data attribute
    'data-lpignore': autoComplete === 'off' || undefined,
    // Dashlane disable data attribute
    'data-form-type': autoComplete === 'off' ? 'other' : undefined
  }));
  var inputWithVerticalContentMarkup = verticalContent ? /*#__PURE__*/React.createElement("div", {
    className: styles.VerticalContent,
    id: "".concat(id, "-VerticalContent"),
    ref: verticalContentRef,
    onClick: handleClickChild
  }, verticalContent, input) : null;
  var inputMarkup = verticalContent ? inputWithVerticalContentMarkup : input;
  var backdropMarkup = /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.Backdrop, connectedLeft && styles['Backdrop-connectedLeft'], connectedRight && styles['Backdrop-connectedRight'])
  });
  var inputAndSuffixMarkup = autoSize ? /*#__PURE__*/React.createElement("div", {
    className: styles.InputAndSuffixWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.AutoSizeWrapper, suffix && styles.AutoSizeWrapperWithSuffix),
    "data-auto-size-value": value || placeholder
  }, inputMarkup), suffixMarkup) : /*#__PURE__*/React.createElement(React.Fragment, null, inputMarkup, suffixMarkup);
  return /*#__PURE__*/React.createElement(Labelled, {
    label: label,
    id: id,
    error: error,
    action: labelAction,
    labelHidden: labelHidden,
    helpText: helpText,
    requiredIndicator: requiredIndicator,
    disabled: disabled,
    readOnly: readOnly
  }, /*#__PURE__*/React.createElement(Connected, {
    left: connectedLeft,
    right: connectedRight
  }, /*#__PURE__*/React.createElement("div", {
    className: className,
    onClick: handleClick,
    ref: textFieldRef
  }, prefixMarkup, inputAndSuffixMarkup, characterCountMarkup, loadingMarkup, clearButtonMarkup, spinnerMarkup, backdropMarkup, resizer)));
  function handleChange(event) {
    onChange && onChange(event.currentTarget.value, id);
  }
  function handleClick(event) {
    var _inputRef$current, _getInputRef;
    var target = event.target;

    // For TextFields used with Combobox, focus needs to be set again even
    // if the TextField is already focused to trigger the logic to open the
    // Combobox activator
    var inputRefRole = inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.getAttribute('role');
    if (target === inputRef.current && inputRefRole === 'combobox') {
      var _inputRef$current2;
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.focus();
      handleOnFocus(event);
      return;
    }
    if (isPrefixOrSuffix(target) || isVerticalContent(target) || isInput(target) || isSpinner(target) || isLoadingSpinner(target) || focus) {
      return;
    }
    (_getInputRef = getInputRef()) === null || _getInputRef === void 0 || _getInputRef.focus();
  }
  function handleClickChild(event) {
    var _getInputRef2;
    if (!isSpinner(event.target) && !isInput(event.target)) {
      event.stopPropagation();
    }
    if (isPrefixOrSuffix(event.target) || isVerticalContent(event.target) || isInput(event.target) || isLoadingSpinner(event.target) || focus) {
      return;
    }
    setFocus(true);
    (_getInputRef2 = getInputRef()) === null || _getInputRef2 === void 0 || _getInputRef2.focus();
  }
  function handleClearButtonPress() {
    onClearButtonClick && onClearButtonClick(id);
  }
  function handleKeyPress(event) {
    var key = event.key,
      which = event.which;
    var numbersSpec = /[\d.,eE+-]$/;
    var integerSpec = /[\deE+-]$/;
    if (!isNumericType || which === Key.Enter || type === 'number' && numbersSpec.test(key) || type === 'integer' && integerSpec.test(key)) {
      return;
    }
    event.preventDefault();
  }
  function handleKeyDown(event) {
    if (!isNumericType) {
      return;
    }
    var key = event.key,
      which = event.which;
    if (type === 'integer' && (key === 'ArrowUp' || which === Key.UpArrow)) {
      handleNumberChange(1);
      event.preventDefault();
    }
    if (type === 'integer' && (key === 'ArrowDown' || which === Key.DownArrow)) {
      handleNumberChange(-1);
      event.preventDefault();
    }
    if ((which === Key.Home || key === 'Home') && min !== undefined) {
      if (onSpinnerChange != null) {
        onSpinnerChange(String(min), id);
      } else if (onChange != null) {
        onChange(String(min), id);
      }
    }
    if ((which === Key.End || key === 'End') && max !== undefined) {
      if (onSpinnerChange != null) {
        onSpinnerChange(String(max), id);
      } else if (onChange != null) {
        onChange(String(max), id);
      }
    }
    if ((which === Key.PageUp || key === 'PageUp') && largeStep !== undefined) {
      handleNumberChange(1, largeStep);
    }
    if ((which === Key.PageDown || key === 'PageDown') && largeStep !== undefined) {
      handleNumberChange(-1, largeStep);
    }
  }
  function handleOnBlur(event) {
    var _textFieldRef$current;
    setFocus(false);

    // Return early if new focus target is inside the TextField component
    if ((_textFieldRef$current = textFieldRef.current) !== null && _textFieldRef$current !== void 0 && _textFieldRef$current.contains(event === null || event === void 0 ? void 0 : event.relatedTarget)) {
      return;
    }
    if (onBlur) {
      onBlur(event);
    }
  }
  function isInput(target) {
    var input = getInputRef();
    return target instanceof HTMLElement && input && (input.contains(target) || input.contains(document.activeElement));
  }
  function isPrefixOrSuffix(target) {
    return target instanceof Element && (prefixRef.current && prefixRef.current.contains(target) || suffixRef.current && suffixRef.current.contains(target));
  }
  function isSpinner(target) {
    return target instanceof Element && spinnerRef.current && spinnerRef.current.contains(target);
  }
  function isLoadingSpinner(target) {
    return target instanceof Element && loadingRef.current && loadingRef.current.contains(target);
  }
  function isVerticalContent(target) {
    return target instanceof Element && verticalContentRef.current && (verticalContentRef.current.contains(target) || verticalContentRef.current.contains(document.activeElement));
  }
}
function getRows(multiline) {
  if (!multiline) return undefined;
  return typeof multiline === 'number' ? multiline : 1;
}
function normalizeAriaMultiline(multiline) {
  if (!multiline) return undefined;
  return Boolean(multiline) || typeof multiline === 'number' && multiline > 0 ? {
    'aria-multiline': true
  } : undefined;
}
export { TextField };